import * as React from 'react'
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl'

import { Card, CardBody } from '../../../../../components/card'
import Checklist from '../../../../../components/checklist'

import styles from './feature-grid-card.module.scss'

const FeatureGridCard = () => {
  const summaryFeatures = [
    <FormattedMessage defaultMessage="Färdiga bokföringsmallar" id="diy-accounting.sub-features.1" key="1" />,
    <FormattedMessage
      defaultMessage="Integration med Skatteverket och bank"
      id="diy-accounting.sub-features.2"
      key="2"
    />,
    <FormattedMessage defaultMessage="Tydliga processer att följa" id="diy-accounting.sub-features.3" key="3" />,
    <FormattedMessage defaultMessage="Smart Att-göra-lista" id="diy-accounting.sub-features.4" key="4" />,
    <FormattedMessage defaultMessage="Deklaration med ett klick" id="diy-accounting.sub-features.5" key="5" />,
    <FormattedMessage defaultMessage="Fota dokument med mobilappen" id="diy-accounting.sub-features.6" key="6" />,
    <FormattedMessage defaultMessage="Importera och exportera bokföring" id="diy-accounting.sub-features.7" key="7" />,
    <FormattedMessage defaultMessage="Alla rapporter du behöver" id="diy-accounting.sub-features.8" key="8" />,
    <FormattedMessage defaultMessage="Obegränsat antal användare" id="diy-accounting.sub-features.9" key="9" />,
    <FormattedMessage defaultMessage="Verifiering med BankID" id="diy-accounting.sub-features.10" key="10" />,
    <FormattedMessage
      defaultMessage="Automatisk registrering av betalningar"
      id="diy-accounting.sub-features.11"
      key="11"
    />,
    <FormattedMessage defaultMessage="Mycket, mycket mer" id="diy-accounting.sub-features.12" key="12" />,
  ]

  return (
    <Card className={styles.root}>
      <CardBody>
        <FormattedHTMLMessage
          defaultMessage="Smarta funktioner du kommer älska"
          id="diy-accounting.sub-features.title"
          tagName="h2"
        />
        <FormattedHTMLMessage
          defaultMessage="Ett komplett bokföringsprogram anpassat för dig"
          id="diy-accounting.sub-features.lede"
          tagName="p"
        />
        <div className={styles.seperator} />
        <Checklist col={3} horizontal items={summaryFeatures} lastIsSeeMore />
      </CardBody>
    </Card>
  )
}

export default FeatureGridCard
